import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as moment from 'moment';
import * as T_T from 'cryface';
import { CallNative } from '../../../services/EpicContextService/call.native';
import { CommonConfig } from '../../../configs/config.common';
import { AxiosPromise } from '../../../utils/axios.promise';
import { NoticeConfig } from 'iview';
@Component
export default class WorkflowClosingDatePickerPage extends Vue {
    public data: string = '';
    public value: string = '';
    public open = false;
    public configs = new CommonConfig();
    public options = {
        shortcuts: [...Array(12).keys()].map((key: number) => ({
            text: `${key + 1}个月`,
            value() {
                return new Date(moment(new Date()).add(key + 1, 'month').toISOString());
            },
            onClick: (picker: any) => {
            }
        })),
        disabledDate(date: any) {
            return date && (date.valueOf()) < moment(new Date()).add(-1, 'days').valueOf();
        }
    };
    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
    @Watch('globalPudge.context', { immediate: true, deep: true })
    public onGlobalPudget(val: any, oldVal: any) {
        const closingDate = this.globalPudge.functions.getParam('closingDate');
        if (T_T.simpleDetect(closingDate)) {
            // this.goDetail();
        } else {
        }
    }
    public created() {
        document.title = ' ';
        const entrustId = this.$route.query['entrustId'];
        const activityId = this.$route.query['activityId'];
        const closingDateSaved = this.globalPudge.functions.getParam('closingDate');
        if (T_T.simpleDetect(closingDateSaved)) {
            this.value = closingDateSaved!.value;
        }
        console.log(this.$route);
        if (T_T.simpleDetect(entrustId) && T_T.simpleDetect(activityId)) {
            this.globalPudge.functions.setParam('entrustId', entrustId);
            this.globalPudge.functions.setParam('activityId', activityId);
            const closingDate = this.$route.query['closingDate'];
            if (T_T.simpleDetect(closingDate)) {
                this.globalPudge.functions.setParam('closingDate', closingDate);
                this.goDetail(true);
            }
        } else {
            console.error('Invalid Query, EId Not Found');
        }
    }
    public mounted() {
        CallNative.runNativeFun(CallNative.ENativeFunctions.NativeSetNavTitle, {
            'title_cn': '交割日期',
            'title_en': 'Closing Date',
        });
    }
    public handleClick() {
        this.open = !this.open;
    }
    public handleChange(date: any) {
        this.value = date;
    }
    public handleClear() {
        this.open = false;
    }
    public handleOk() {
        this.open = false;
    }
    public goDetail(finished: boolean) {
        this.$router.replace(`/hybrid/closing-date/summary?finished=${finished}`);
    }
    public async agentLog() {
        const apiHost = this.configs.cimsServHost;
        const activityId = this.globalPudge.functions.getParam('activityId');
        if (T_T.simpleDetect(activityId)) {
            const postBody = {
                activityId: activityId!.value,
                ltype: 1,
            };
            const fetched = await AxiosPromise.postUrlEncode(`${apiHost}/agentLog/insert`, postBody);
            // console.log(fetched);
        } else {
            console.log('EpicContext Error: Empty activityId--------------------------------------------');
        }
    }

    public async workflowDone() {
        const apiHost = this.configs.cimsServHost;
        const activityId = this.globalPudge.getParam('activityId');
        const entrustId = this.globalPudge.getParam('entrustId');
        if (T_T.simpleDetect(activityId) && T_T.simpleDetect(entrustId)) {
            const fetched = await AxiosPromise.get(`${apiHost}/bimsEntrust/doneWorkFlow?activityId=${activityId}&entustId=${entrustId}&ltype=1&forceDone=1`);
            // console.log(fetched);
        } else {
            console.log('EpicContext Error: Empty activityId or entrustId--------------------------------------------');
        }
    }
    public async onSubmit() {
        const apiHost = this.configs.cimsServHost;
        const entrustId = this.globalPudge.functions.getParam('entrustId');
        const activityId = this.globalPudge.functions.getParam('activityId');
        if (T_T.simpleDetect(entrustId) && T_T.simpleDetect(activityId)) {
            if (T_T.simpleDetect(this.value)) {
                const body = {
                    entrustId: Number(entrustId!.value),
                    // activityId: activityId,
                    dateClosed: this.value,
                    ltype: 0,
                };
                const fetched = await AxiosPromise.postUrlEncode(`${apiHost}/bimsEntrust/setClosingDate`, body);
                await this.agentLog();
                await this.workflowDone();
                if (fetched.status === 200) {
                    if (fetched.data.code === 200) {
                        const noticeConfig: NoticeConfig = {
                            title: 'Operation Succeed',
                            desc: 'Thanks For Choosing RIFO.'
                        };
                        this.$Notice.success(noticeConfig);
                        this.globalPudge.functions.setParam('closingDate', this.value);
                        this.goDetail(false);
                    }
                }
            }
        } else {
            console.error('Invalid Query');
        }
    }
}
